<template>
  <div>
    <v-select
      taggable
      placeholder="Choose One"
      :class="errorClassOnNull(item.name)"
      @search="fetchItemsOptions"
      :value="item"
      @input="itemSelected"
      :options="itemOptions"
      :create-option="
        (name) => ({
          name: name,
          category_1: null,
          category_2: null,
          unit_price: 0,
        })
      "
      label="name"
    >
      <template v-slot:option="option">
        <div>
          <span class="text-bold text-capitalize">{{ option.name }}</span
          ><br />
          <span v-if="option.category_1">{{ option.category_1 }}</span>
          <span v-if="option.category_2"> | {{ option.category_2 }}</span>
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  props: ["selectedIndex", "item"],
  data() {
    return {
      itemOptions: [],
    };
  },
  methods: {
    async fetchItemsOptions(keyword = null) {
      let res = await axios.get("accounting/invoice_items", {
        params: { keyword },
      });
      this.itemOptions = res.data;
    },
    itemSelected(item) {
      if (!item) {
        let data = {};
        data["name"] = null;
        data["unit_price"] = 0;
        data["selectedIndex"] = this.selectedIndex;
        this.$emit("input", data);
      } else {
        item["selectedIndex"] = this.selectedIndex;
        this.$emit("input", item);
      }
    },
    errorClassOnNull(value) {
      if (!value) {
        return "error";
      }
    },
  },
  mounted() {
    this.fetchItemsOptions();
  },
};
</script>

<style scoped>
.error {
  border: 1px solid red !important;
  border-radius: 5px !important;
}
</style>
